import { render, staticRenderFns } from "./SettingsNav.vue?vue&type=template&id=630785e8&scoped=true&"
import script from "./SettingsNav.vue?vue&type=script&lang=js&"
export * from "./SettingsNav.vue?vue&type=script&lang=js&"
import style0 from "./SettingsNav.vue?vue&type=style&index=0&id=630785e8&prod&lang=scss&scoped=true&"
import style1 from "./SettingsNav.vue?vue&type=style&index=1&id=630785e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630785e8",
  null
  
)

export default component.exports